import React, { useState } from "react";
import api, { formatApiErrorDetail } from "../lib/api";
import { Button } from "./ui/button";
import { Upload, FileIcon, X } from "lucide-react";
import { toast } from "sonner";

export function FileUploader({ value = [], onChange, label = "Attachments", testId = "file-uploader" }) {
  const [uploading, setUploading] = useState(false);

  const onPick = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploading(true);
    try {
      const uploaded = [];
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
        uploaded.push(data);
      }
      onChange([...(value || []), ...uploaded]);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Upload failed");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  const remove = (i) => onChange(value.filter((_, idx) => idx !== i));

  return (
    <div data-testid={testId}>
      <label className="block text-sm font-medium text-slate-700 mb-2">{label}</label>
      <label className="flex flex-col items-center justify-center border-2 border-dashed border-slate-300 rounded-md py-6 cursor-pointer hover:border-orange-400 hover:bg-orange-50/40 transition-colors">
        <Upload className="w-6 h-6 text-slate-400 mb-2" />
        <span className="text-sm text-slate-600">{uploading ? "Uploading..." : "Click to upload (PDF, JPG, PNG · max 20MB)"}</span>
        <input type="file" multiple accept=".pdf,.jpg,.jpeg,.png" onChange={onPick} className="hidden" data-testid={`${testId}-input`} />
      </label>
      {value?.length > 0 && (
        <ul className="mt-3 space-y-1.5">
          {value.map((f, i) => (
            <li key={f.url || `${f.filename}-${i}`} className="flex items-center justify-between bg-slate-50 border border-slate-200 rounded px-3 py-2 text-sm">
              <a href={`${process.env.REACT_APP_BACKEND_URL}${f.url}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-slate-700 hover:text-orange-700 truncate">
                <FileIcon className="w-4 h-4" />
                <span className="truncate">{f.filename}</span>
              </a>
              <button type="button" onClick={() => remove(i)} className="text-slate-400 hover:text-red-600" data-testid={`${testId}-remove-${i}`}>
                <X className="w-4 h-4" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
